<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Vcwtnx/tc-custom/9781646040988.jpg?1737780139040" alt="This image is the cover for the book Who Invented Underpants?, Fascinating Bathroom Readers"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Who Invented Underpants?, Fascinating Bathroom Readers
      </h1>
      <p class="bookDescription body article font2">
        <b>A comprehensive collection of fun facts about the origins of pretty much everything, from windows to washing machines to websites. </b><br/><br/>This fact-packed collection recounts the origins, invention, and discovery of just about everything, from the big bang to driverless cars. With sections covering topics such as the arts, sports, weapons, buildings, medicine, food, and many more, you can find out intriguing answers to questions like:<br/><br/><i>What material was the first clothing made out of?</i><br/><br/><i>Who invented bathtubs?</i><br/><br/><i>Who paved the first road?</i><br/><br/><i>What came first: wine or whiskey?</i><br/><br/>Perfect for history buffs, science lovers, or all-around trivia junkies, this entertaining and enlightening collection is for curious minds wondering about the mysteries of the beginning of all things.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Stewart Ross
      </h2>
      
      <p class="authorDescription body article">As well as fiction and non-fiction titles, Stewart Ross has written prize-winning books for children (his book The Story of Scotland won the Saltire Society prize). He is a French speaker and teaches and directs plays in France; he also gives workshops and talks in the UK and further afield.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Ulysses Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?f98bd1c2